module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2019/march-ff8b5a3aba3e290a2cfadf42b30ae4e1.png";